import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import React from 'react';

import { CupIcon } from '@/assets/icons/CupIcon.tsx';
import { XIcon } from '@/assets/icons/XIcon.tsx';
import type { CompetitionWinner } from '@/lib/api/requests.ts';

import { CompetitionWinnersList } from '../CompetitionWinnersList/index.ts';

export type CompetitionWinnersDialogProps = {
  open: boolean;
  onClose?: () => void;
  winners: CompetitionWinner[];
};

export const CompetitionWinnersDialog: React.FC<CompetitionWinnersDialogProps> = ({
  open,
  onClose,
  winners,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ zIndex: 20_000 }}
      fullWidth
      maxWidth={winners.length > 10 ? 'xl' : 'md'}
      slotProps={{
        paper: {
          sx: {
            color: (theme) => theme.palette.text.default,
            borderRadius: '8px',
            boxShadow: 'none',
          },
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <Box
          sx={{
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            mb: 2,
            mt: 2,
          }}
        >
          <CupIcon />
          <h2 className="typography-v1-h3">Liste over vinnere</h2>
        </Box>
        <IconButton
          sx={{
            color: (theme) => theme.palette.primary.main,
            mt: -1.5,
            mr: -2.5,
          }}
          onClick={onClose}
        >
          <XIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
        <CompetitionWinnersList winners={winners} />
      </DialogContent>
    </Dialog>
  );
};
